import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, User, ChevronDown } from 'lucide-react';
import { useAuthStore } from '@/store/auth';
import { api } from '@/lib/api';

export function TopBar() {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();
  const [showDropdown, setShowDropdown] = useState(false);

  const handleLogout = async () => {
    try {
      await api.post('/auth/logout');
    } catch {
      // Ignore errors
    }
    logout();
    navigate('/login');
  };

  const roleLabels: Record<string, string> = {
    owner: 'Owner',
    manager: 'Manager',
    marketing: 'Marketing',
    staff: 'Staff',
  };

  return (
    <header className="flex h-16 items-center justify-between border-b border-midnight-100 bg-midnight-50 px-6">
      {/* Breadcrumbs or title could go here */}
      <div />

      {/* User dropdown */}
      <div className="relative">
        <button
          onClick={() => setShowDropdown(!showDropdown)}
          className="flex items-center gap-3 rounded-lg px-3 py-2 hover:bg-midnight-100 transition-colors"
        >
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gold/20">
            <User className="h-4 w-4 text-gold" />
          </div>
          <div className="text-left">
            <p className="text-sm font-medium text-white">{user?.name}</p>
            <p className="text-xs text-gray-500">{roleLabels[user?.role ?? ''] ?? user?.role}</p>
          </div>
          <ChevronDown className="h-4 w-4 text-gray-500" />
        </button>

        {showDropdown && (
          <>
            <div
              className="fixed inset-0 z-10"
              onClick={() => setShowDropdown(false)}
            />
            <div className="absolute right-0 z-20 mt-2 w-48 rounded-lg border border-midnight-100 bg-midnight-50 py-1 shadow-xl">
              <div className="border-b border-midnight-100 px-4 py-2">
                <p className="text-sm text-white">{user?.email}</p>
              </div>
              <button
                onClick={handleLogout}
                className="flex w-full items-center gap-2 px-4 py-2 text-sm text-red-400 hover:bg-midnight-100"
              >
                <LogOut className="h-4 w-4" />
                Sign out
              </button>
            </div>
          </>
        )}
      </div>
    </header>
  );
}
